import React from 'react';
import './Auth.css';

const VerifyCode = () => {
  return (
    <div className="auth-container">
      <h2>Check your email</h2>
      <p>We sent a reset link to your email. Enter the 5-digit code mentioned in the email.</p>
      <form className="auth-form">
        <div className="code-inputs">
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
          <input type="text" maxLength="1" />
        </div>
        <button type="submit" className="auth-btn">Verify Code</button>
        <div className="auth-links">
          Haven't got the email yet? <button type="button" className="link-btn">Resend email</button>
        </div>
      </form>
    </div>
  );
};

export default VerifyCode; 